import BaseValidator from './base';

export default class Regex extends BaseValidator {
  message = ' is not valid';

  isValid = () => {
    if (this.input) {
      const value = this.input.value.trim();

      return !value || this.regex.test(value);
    }

    return true;
  };
}
